
// authService.js

const cognitoDomain = "https://login.cast-n-track.online";
const clientId = "3n829u0fbc6u3lij5ek5hge5bp";
const redirectUri = "https://cast-n-track.online/app";
const tokenEndpoint = `${cognitoDomain}/oauth2/token`;

const responseType = 'code';
const loginUrl = `${cognitoDomain}/login?client_id=${clientId}&response_type=${responseType}&scope=email+openid&redirect_uri=${encodeURIComponent(redirectUri)}`;

const logoutRedirect = "https://cast-n-track.online";
const logoutUrl = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutRedirect)}`;

const idToken = "id_token" ;
const accessToken = "access_token" ;
const refreshToken = "refresh_token";
const tokenTimestamp = "token_timestamp";

function fromLocalStorage( key ) { return localStorage.getItem( key ) ; }
function saveToLocalStorage ( key, value ) { localStorage.setItem( key, value ) ; }

function timestampFromString( strValue ) { return parseInt( strValue || "0", 10); }

let authReadyPromiseResolve ;
const authReadyPromise = new Promise((resolve) => { authReadyPromiseResolve = resolve ; } ) ;


export async function handleOAuthRedirect() {
  const params = new URLSearchParams(window.location.search);
  const code = params.get('code');
  if ( code ) {
    const body = new URLSearchParams({
      grant_type: "authorization_code",
      client_id: clientId,
      redirect_uri: redirectUri,
      code,
    });

    const response = await fetch(tokenEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body,
    });

    if (!response.ok) throw new Error("Failed to exchange code for tokens");

    const data = await response.json();
    const now = Date.now();

    saveToLocalStorage(idToken, data.id_token);
    saveToLocalStorage(accessToken, data.access_token);
    saveToLocalStorage(refreshToken, data.refresh_token);
    saveToLocalStorage(tokenTimestamp, now.toString());

    // resolve the authReady, so other tasks can proceed
    authReadyPromiseResolve();

    // Clean up the URL
    window.history.replaceState({}, document.title, redirectUri);
  }
}

async function refreshTokens() {
  const localRefreshToken = fromLocalStorage(refreshToken);
  if (!localRefreshToken) { // no refresh token - redirect to login
    console.log('No refresh token, redirecting to login') ;
    window.location.href = loginUrl;
    return;
  }

  const body = new URLSearchParams({
    grant_type: "refresh_token",
    client_id: clientId,
    refresh_token: localRefreshToken,
  });

  const response = await fetch(tokenEndpoint, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body,
  });

  if (!response.ok) { // refresh token failed - redirect to login
    console.log('Refresh token failed, redirecting to login') ;
    window.location.href = loginUrl;
    return;
  }

  const data = await response.json();
  const now = Date.now();

  if (data.id_token) {
    saveToLocalStorage(idToken, data.id_token);
    saveToLocalStorage(tokenTimestamp, now.toString());
  }

  if (data.access_token) {
    saveToLocalStorage(accessToken, data.access_token);
  }

}

export async function getValidIdToken() {
  await authReadyPromise;
  const token = fromLocalStorage(idToken);
  const timestamp = timestampFromString(fromLocalStorage(tokenTimestamp));
  const oneHour = 60 * 60 * 1000;

  if (token && Date.now() - timestamp < oneHour) {
    return token;
  }

  await refreshTokens();
  return fromLocalStorage(idToken);
}

export function processLogout() {
  localStorage.removeItem("id_token");
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("token_timestamp");
  window.location.href = logoutUrl;
}
